import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { CustomGridsterItem } from '../../../../pages/CustomisableReports/customisablereports.component';
import { EveReportingImageWidget } from '../../image-widget/image-widget.component';



@Component({
  selector: 'image-widget-menu-settings',
  templateUrl: './image-widget-menu-settings.component.html',
  styleUrls: ['./image-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class ImageWidgetMenuSettingsComponent {

  @Input()
  widget?: EveReportingImageWidget = null;
}



